import { styled } from 'src/styles/stitches.config'

export const TicketsWrapper = styled('div', {
    backgroundColor: '#1d1d1b',
    color: '$brand',
    padding: '$sm 0',
})
